module.exports = __webpack_public_path__ + "img/chenweier.a82989d9.jpg";